<div [formGroup]="form" class="w-full">
    <!-- ===== Misure S ===== -->
    <div class="misure-section" *ngIf="sKeys.length">
        <div class="misure-section-title">Misure</div>
        <div class="misure-grid">
            <div *ngFor="let s of sKeys" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ s.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[s] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + s" class="misura-input" [ngClass]="getInputClass(s)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(s)" [ngClass]="getTrendIcon(s)"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== Quote / regole ===== -->
    <div class="misure-section" *ngIf="ruleKeys.length">
        <div class="misure-section-title">Quote</div>
        <div class="misure-grid">
            <div *ngFor="let x of ruleKeys" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ x.toUpperCase() }}</span>
                    <span class="misura-ref">{{ normativa?.['op' + x.toUpperCase()] }} {{ normativa?.[x] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + x" class="misura-input" [ngClass]="getRuleClass(x)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(x)" [ngClass]="getTrendIcon(x)"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== Extra ===== -->
    <div class="misure-section" *ngIf="extraKeys.length">
        <div class="misure-section-title">Altre quote</div>
        <div class="misure-grid">
            <div *ngFor="let x of extraKeys" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ x.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[x] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + x" class="misura-input" />
                    <i class="misura-trend" *ngIf="getTrendIcon(x)" [ngClass]="getTrendIcon(x)"></i>
                </div>
            </div>
        </div>
    </div>
</div>
